import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 10px;
  min-width: 200px;

  > div:first-child {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));

    > div:not(.product-quantity) {
      > div {
        > div {
          line-height: 1;
        }

        .react-select__control {
          height: 50px;
        }
      }
    }
  }
`

export const EmptyWrapper = styled(Wrapper)`
  margin: 0 10px;
  min-width: 100px;
  padding: 20px 0;
`

export const Message = styled.div`
  padding: 10px;
  font-weight: bold;
  color: ${props => props.theme.palette.state.danger};
  max-width: 180px;
`
